import { LabJobStatus } from '@principle-theorem/principle-core/interfaces';
import {
  IAvroSerialisedVersionedSchema,
  ISerialisedDocumentReference,
  ISerialisedTimestamp,
} from '@principle-theorem/shared';
import {
  IBigQueryFirestoreModel,
  IBigQueryNamedDocument,
  IBigQueryReffable,
  IBigQueryStatusHistory,
  ITimestampedDimension,
} from './common';
import { IBigQueryLabJobType } from './lab';
import { IBigQueryWorkflowItem } from './task';

export interface ILabJobDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    IBigQueryWorkflowItem,
    ITimestampedDimension {
  lab: IBigQueryNamedDocument;
  status: LabJobStatus;
  statusHistory: IBigQueryStatusHistory<LabJobStatus>[];
  patient: IBigQueryNamedDocument;
  appointment?: {
    treatmentPlanName?: string;
    ref: ISerialisedDocumentReference;
  };
  practitioner?: IBigQueryNamedDocument;
  type: IBigQueryLabJobType;
  cost: number;
  description?: IAvroSerialisedVersionedSchema;
  sentAt?: ISerialisedTimestamp;
  receivedAt?: ISerialisedTimestamp;
  issuedAt?: ISerialisedTimestamp;
}
